import firebase from "firebase/compat/app";
import "firebase/compat/database";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_TRANSLATIONS_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_TRANSLATIONS_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_TRANSLATIONS_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_TRANSLATIONS_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_TRANSLATIONS_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_TRANSLATIONS_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_TRANSLATIONS_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_TRANSLATIONS_FIREBASE_MEASURMENT_ID,
};

let translationsApp = null;
try {
  translationsApp = firebase.initializeApp(firebaseConfig, "translations");
} catch (e) {
  if (e.code === "app/duplicate-app") {
    translationsApp = firebase.app("translations");
  } else {
    throw e;
  }
}

export const getTranslationsVersion = async () => {
  const snapshot = await translationsApp.database().ref("/translations/version").once("value");
  return snapshot.val();
};

export const getTranslations = async () => {
  const snapshot = await translationsApp.database().ref("/translations").once("value");
  return snapshot.val();
};
